import BaseRequest from './index'
import { GET_COLLABO_INVITES, GET_COLLABO, SEARCH_USER } from './api'
import {} from './types'

class CollaboService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }
  bindMethods() {
    this.getAllcollaboInvites = this.getAllcollaboInvites.bind(this)
    this.getAllcollabo = this.getAllcollabo.bind(this)
    this.acceptcollaboInvite = this.acceptcollaboInvite.bind(this)
    this.rejectcollaboInvite = this.rejectcollaboInvite.bind(this)
  }
  async getAllcollaboInvites<T>(): Promise<T> {
    return await this.api.get(GET_COLLABO_INVITES)
  }
  async getAllcollabo<T>(): Promise<T> {
    return await this.api.get(GET_COLLABO)
  }
  async acceptcollaboInvite<T>(data: any): Promise<T> {
    return await this.api.post(`user/collabo/invite/${data.id}/accept`, data)
  }
  async searchUser<T>(data: any): Promise<T> {
    return await this.api.post(SEARCH_USER, data)
  }
  async rejectcollaboInvite<T>(id: string): Promise<T> {
    return await this.api.delete(`user/collabo/invite/${id}/reject`)
  }
}
const collaboservicee = new CollaboService()

export default collaboservicee
